import * as React from 'react';
/**
 * This hook is for creating a state which can either be controlled or uncontrolled.
 */
export default function useControlled(_ref) {
  var {
    default: defaultValueProp,
    controlled: valueProp
  } = _ref;
  var {
    current: isControlled
  } = React.useRef(valueProp !== undefined);
  var [defaultValue, setDefaultValue] = React.useState(defaultValueProp);
  var value = isControlled ? valueProp : defaultValue;
  var setUncontrolledValue = React.useCallback(newValue => {
    if (!isControlled) {
      setDefaultValue(newValue);
    }
  }, [isControlled]);
  return [value, setUncontrolledValue, isControlled];
}